const ArrowsRepeat = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.95817 1.25L11.8748 3.95833L8.95817 6.66667M11.0415 13.3333L8.12484 16.0417L11.0415 18.75M8.95817 16.0417H11.6665C15.0032 16.0417 17.7082 13.3367 17.7082 10C17.7082 8.1792 16.9027 6.54652 15.6287 5.43884M11.0415 3.95833H8.33317C4.99645 3.95833 2.2915 6.66328 2.2915 10C2.2915 11.8212 3.0973 13.4542 4.37182 14.5619"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowsRepeat
